import React from 'react';
import PostAuthor from './PostAuthor'

const PostEmpty = () => {
  return (
    <div>
      <div className="article speech-bubble">
        <aside className="labels">
          <span className="label">
            <i style={{backgroundColor:'blue'}}></i>
            Atualização
          </span>
        </aside>
        <h2>Nenhum post publicado</h2>
        <div className="post-body">
          <div>
              Olááááa, você ainda não possui nenhum post publicado :)
          </div>
        </div>  
      </div>
      <PostAuthor post={{
        author: {
          name: 'Luiz',
          avatarUrl: 'https://avatars1.githubusercontent.com/u/372420?s=460&v=4'
        }
      }} />
    </div>
  )
} 

export default PostEmpty;